var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.243 3.171c-1.246 0-1.6.55-1.6 1.763v2.001h3.314l-.326 3.242H6.642V20H2.676v-9.824H0V6.934h2.677V4.99C2.677 1.72 3.995 0 7.691 0 8.484 0 9.433.063 10 .141v3.044"
})));
export default SvgFacebook24;